
import './App.css';
import Home from './components/Home';
import ProjectDishop from './components/project-dishop';
import ProjectOdenlo from './components/project-odenlo';
import ProjectFleet from './components/project-fleet';
import ProjectsMultiple from './components/projects-multiple';
import About from './components/about';
import Contact from './components/contact';
import BCard from './components/BCard';
import Latest from './components/latest';

import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

const windowH = window.innerHeight + 'px';

function App() {
  const location = useLocation ();

  return (
    <AnimatePresence mode='wait'>

    <Routes location={location} key={location.pathname}>
      <Route path="/" element= {<Home/>} />
      <Route path="/project-odenlo" element= {<ProjectOdenlo/>} />
      <Route path="/project-dishop" element= {<ProjectDishop/>} />
      <Route path="/project-fleet" element= {<ProjectFleet/>} />
      <Route path="/projects-multiple" element= {<ProjectsMultiple/>} />
      <Route path="/about" element= {<About/>} />
      <Route path="/contact" element= {<Contact/>} />
      <Route path="/bcard" element= {<BCard/>} />
      <Route path="/latest" element= {<Latest/>} />
        <Route path="*" element={<Home />} />

    </Routes>

    </AnimatePresence>

   /*  <div className="App">      
      <div>
      Rest of the code 
      <Home/>
      </div>      
    
    </div>
    */

  );
}

export default App;
